import type { Theme } from "@shared/events";

/**
 * OWNED BY C1. Theme application (F-207). `mode` sets data-theme on <html> ("system" removes it so
 * prefers-color-scheme decides); `accent` repoints the --accent tokens at the chosen palette entry,
 * which resolves per theme because the palette itself is defined in both.
 */
export function applyTheme(theme: Theme, root: HTMLElement = document.documentElement): void {
  if (theme.mode === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme.mode);
  root.style.setProperty("--accent", `var(--${theme.accent})`);
  root.style.setProperty("--accent-ink", `var(--${theme.accent}-ink)`);
  root.style.setProperty("--accent-soft", `color-mix(in srgb, var(--${theme.accent}) 14%, var(--surface))`);
}

export const THEME_MODES = [
  { value: "system", label: "System" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
] as const satisfies ReadonlyArray<{ value: Theme["mode"]; label: string }>;
